import { POST } from "../../index";
export const selectAllBrand = (param) => POST("/v1/BrandType/selectAllBrand", param);
export const insertBrand = (param) => POST("/v1/BrandType/insertBrand", param);
export const updateBrand = (param) => POST("/v1/BrandType/updateBrand", param);
export const deleteBrand = (param) => POST("/v1/BrandType/deleteBrand", param);
export const selectAllBrandType = (param) => POST("/v1/BrandType/selectAllBrandType", param);
export const insertBrandType = (param) => POST("/v1/BrandType/insertBrandType", param);
export const updateBrandType = (param) => POST("/v1/BrandType/updateBrandType", param);
export const deleteBrandType = (param) => POST("/v1/BrandType/deleteBrandType", param);